import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { PlanejamentoCarga } from '../../types/estoque';
import { planejamentoCargasService } from '../../services';

const columns: ResourceColumn<PlanejamentoCarga>[] = [
  { header: "Carga", render: (item) => "#" + item.id },
  { header: "Data", accessor: "data_planejamento" },
  { header: "Transportadora", accessor: "transportadora" },
  { header: "Status", accessor: "status" },
  { header: "Capacidade (kg)", accessor: "capacidade_total_kg" }
];

export const PlanejamentoCargasListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Planejamento de cargas"
    description="Planejamentos logísticos previstos."
    columns={columns}
    service={planejamentoCargasService}
    createPath="/admin/estoque/planejamento-cargas/novo"
      onEdit={(item) => item.id && navigate("/admin/estoque/planejamento-cargas/editar", { state: { record: item } })}
  />
  );
};